import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { VLogoCustomer } from 'src/app/models/entities/v-logo-customer';
import { LogoService } from 'src/app/services/logo.service';

@Component({
  selector: 'app-logo-customer',
  templateUrl: './logo-customer.component.html',
  styleUrls: ['./logo-customer.component.css']
})
export class LogoCustomerComponent implements OnInit {

  logoCustomers$: Observable<VLogoCustomer[]>;
  @ViewChild('dt', { static: false }) dt: any;
  constructor(private logoService: LogoService) { }

  ngOnInit(): void {
    this.logoCustomers$ = this.logoService.getCustomers().pipe(map(result => result.data));
  }

  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }


}
